"use client";

import { useCallback } from "react";
import { useHeaderContext } from "./header.context";
import type { HeaderMobileMenuToggleProps } from "./types/header-menu-toggle.types";
import {
  headerMobileMenuToggleStyles,
  headerMenuToggleIconStyles,
  headerMenuToggleIconLineStyles,
} from "./styles/header-mobile-menu-toggle.styles";

export const HeaderMobileMenuToggle: React.FC<HeaderMobileMenuToggleProps> = (props) => {
  const { className, onClick, "aria-label": ariaLabel, ...rest } = props;

  const { toggleMenu, menuOpen, menuId } = useHeaderContext();

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      toggleMenu();
      onClick?.(e);
    },
    [toggleMenu, onClick],
  );

  return (
    <button
      className={headerMobileMenuToggleStyles({ className })}
      onClick={handleClick}
      aria-label={ariaLabel ?? (menuOpen ? "Close menu" : "Open menu")}
      aria-expanded={menuOpen}
      aria-controls={menuId}
      {...rest}
    >
      <span role="presentation" className={headerMenuToggleIconStyles()}>
        <span className={headerMenuToggleIconLineStyles({ position: "start", menuOpen })}></span>
        <span className={headerMenuToggleIconLineStyles({ position: "center", menuOpen })}></span>
        <span className={headerMenuToggleIconLineStyles({ position: "end", menuOpen })}></span>
      </span>
    </button>
  );
};

HeaderMobileMenuToggle.displayName = "HeaderMobileMenuToggle";
